import { ReferenceToSubmit } from 'features/Connect/features/ConnectATSIntegration/HiringRequests/components/CandidateFeedback/components/Panes/Create/Reference/AddContact/types';
import { BaseNimbleAPI } from './baseAPI';

class referenceCheckV2API extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/v2/referencechecks' };
  }

  async create(reference: ReferenceToSubmit | FormData) {
    const response = await this.post('/', reference);
    return response.data;
  }
}

export default new referenceCheckV2API();
